export const GUEST_APPOINTMENT_TAG = 'guest-appointment';
export const GUEST_APPOINTMENT_KEY = 'guest_appointment_id';
export const SEGMENT_FLOW_TRACKED_KEY = 'segment-flow-tracked';
export const ZOCDOC_APPOINTMENT_KEY = 'zocdocAppointmentId';
